<template>
  <!-- Visão em Lista -->
  <v-container fluid grid-list-xs pa-0 mt-1>
    <v-layout v-if="agrupadorItems.length" row class="overflow-x-auto">
      <!-- <v-flex xs12 sm4 md3 grow v-for="agrupador in agrupadorAtual" :key="agrupador.IdSituacao || agrupador" mx-1 class="grey lighten-2 shadow"> -->
      <v-flex xs12 sm4 md3 grow mx-1 class="grey lighten-2 shadow" v-for="agrupador in agrupadorItems" :key="agrupador.IdSituacao">
        <v-layout row align-center>
          <v-subheader class="font-weight-bold">
            <!-- {{ agrupador.Descricao || moment(agrupador).format('DD [de] MMMM [de] YYYY') }} -->
            {{ agrupador.Descricao }}
          </v-subheader>
          <v-spacer></v-spacer>
          <v-subheader class="font-weight-bold">
            {{ itemsPorAgrupador(agrupador).length }}
            {{ itemsPorAgrupador(agrupador).length > 1 ? 'projetos' : 'projeto' }}
          </v-subheader>
        </v-layout>
        <v-divider class="mb-2"></v-divider>
        <v-layout column px-2 class="overflow-y-auto">
          <v-card 
            v-for="item in itemsPorAgrupador(agrupador)"
            :key="item.IdProjeto" 
            class="mb-2 cursor-pointer"
            @dblclick="$emit('editItem', item.IdProjeto)"
          >
            <v-card-title primary-title class="pa-2">
              <v-flex xs12>
                <v-layout row align-center>
                  <div class="subheading font-weight-medium">{{ item.Projeto }}</div>
                  <v-spacer></v-spacer>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                      >
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-tile
                        @click="$emit('editItem', item.IdProjeto)"
                      >
                        <v-list-tile-title>
                          <v-icon small class="pr-1">edit</v-icon>
                            Alterar
                          </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="$emit('emiteEvento', { evento: 'deleteItem', item })"
                      >
                        <v-list-tile-title>
                          <v-icon small class="pr-1">delete</v-icon>
                          Excluir
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="$emit('emiteEvento', { evento: 'finalizaItem', item })"
                      >
                        <v-list-tile-title>
                          <v-icon small class="pr-1">check</v-icon>
                          Finalizar
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile class="cursor-pointer">
                        <v-list-tile-title @click="$emit('emiteEvento', { evento: 'abreModalDuplicaProjeto', item })">
                          <v-icon small class="pr-1">label</v-icon>
                          Duplicar Projeto
                        </v-list-tile-title>
                      </v-list-tile>
                      <!-- <v-list-tile class="cursor-pointer">
                        <v-list-tile-title @click="$emit('emiteEvento', { evento: 'abreModalEditPrevisao', item })">
                          <v-icon small class="pr-1">event</v-icon>
                          Setar Previsão
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile class="cursor-pointer">
                        <v-list-tile-title @click="$emit('emiteEvento', { evento: 'abreModalEditSituacao', item })">
                          <v-icon small class="pr-1">description</v-icon>
                          Setar Situação
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile class="cursor-pointer">
                        <v-list-tile-title @click="$emit('emiteEvento', { evento: 'abreModalEditResponsavel', item })">
                          <v-icon small class="pr-1">person</v-icon>
                          Setar Responsável
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile class="cursor-pointer">
                        <v-list-tile-title @click="$emit('emiteEvento', { evento: 'abreModalEditTipoAtividade', item })">
                          <v-icon small class="pr-1">label_important</v-icon>
                          Setar Tipo Atividade
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile class="cursor-pointer">
                        <v-list-tile-title @click="$emit('emiteEvento', { evento: 'abreModalEditColaborador', item })">
                          <v-icon small class="pr-1">group_add</v-icon>
                          Setar Colaborador
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile class="cursor-pointer">
                        <v-list-tile-title @click="$emit('emiteEvento', { evento: 'abreModalEditTag', item })">
                          <v-icon small class="pr-1">label</v-icon>
                          Setar Tag
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile class="cursor-pointer">
                        <v-list-tile-title @click="$emit('emiteEvento', { evento: 'abreModalEditCliente', item })">
                          <v-icon small class="pr-1">label</v-icon>
                          Setar Cliente
                        </v-list-tile-title>
                      </v-list-tile> -->
                    </v-list>
                  </v-menu>
                </v-layout>
                <v-divider class="my-1"></v-divider>
                <div>
                  <v-icon small>folder_open</v-icon> {{ item.IdProjeto }}
                </div>
                <div>
                  <v-icon small>event</v-icon> {{ moment(item.DataPrevisao).format('DD [de] MMMM [de] YYYY') }}
                </div>
                <div><v-icon small>person</v-icon> {{ item.Responsavel }}</div>
                <div v-if="item.Fantasia"><v-icon small>group_add</v-icon> {{ item.Fantasia }}</div>
                <div><v-chip label dark small :color="item.Cor">{{ item.Situacao }}</v-chip></div>
                <div v-if="item.Tags"><v-chip label small v-for="(tag, index) in converteStringTagsEmArray(item.Tags)" :key="index">{{ tag }}</v-chip></div>
                <div>
                  <v-progress-circular
                    class="mr-1"
                    :size="36"
                    :value="item.ValorGut || 0"
                    :color="matrizGutColor(item.ValorGut || 0)"
                  >
                    <span class="font-weight-medium">{{ item.ValorGut || 0 }}</span>
                  </v-progress-circular>
                  <v-progress-circular
                    v-if="item.ValorNps !== null && item.ValorNps !== undefined"
                    :size="36"
                    :value="npsValue(item.ValorNps)"
                    :color="npsColor(item.ValorNps)"
                  >
                    <span class="font-weight-medium">{{ item.ValorNps }}</span>
                  </v-progress-circular>
                </div>
              </v-flex>
            </v-card-title>
          </v-card>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout v-else align-center column justify-center>
      <v-flex xs4 align-center>
        <v-alert
          :value="true"
          type="warning"
          class="font-weight-bold"
        >
          Nenhuma situação informada no Layout! Na VISÃO COLUNA é necessario ter situações no Layout!.<br>
          Possíveis soluções: Altere a visualização para lista no ícone <v-icon color="black">view_list</v-icon> no canto superior direito, ou adicione as situações no Layout.
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { matrizGutHelper } from '@/utils/matrizGutHelper';
import { npsHelper } from '@/utils/npsHelper';

export default {
  name: 'NewColumnProjetosView',
  props: ["items", "agrupadorItems", "searchField", "searchTerm", "loading"],
  // computed: {
  //   agrupadorOrdenado() {
  //     return this.agrupadorItems.sort((a, b) => a.Ordem > b.Ordem ? 1 : -1);
  //   }
  // },
  methods: {
    npsValue(valor) {
      return npsHelper.npsValue(valor);
    },
    npsColor(valor) {
      return npsHelper.npsColor(valor);
    },
    matrizGutColor(valor) {
      return matrizGutHelper.matrizGutColor(valor);
    },
    itemsPorAgrupador(agrupador) {
      if (this.searchTerm) {
        let exp = new RegExp(this.searchTerm.trim(), 'i');
        return this.items.filter(item => item.IdSituacao === agrupador.IdSituacao).filter(item => exp.test(item[this.searchField]))
          .sort((a, b) => (a.Projeto.toUpperCase() > b.Projeto.toUpperCase()) ? 1 : -1);
      } else {
        return this.items.filter(item => item.IdSituacao === agrupador.IdSituacao)
          .sort((a, b) => (a.Projeto.toUpperCase() > b.Projeto.toUpperCase()) ? 1 : -1);
      }
    },
    converteStringTagsEmArray(tags) {
      if (tags.includes(';')) {
        return tags.split(';');
      } else {
        return [tags];
      }
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
  height: 14px !important;
}
.cursor-pointer {
  cursor: pointer;
}
.overflow-x-auto {
  overflow-x: auto;
  height: calc(100vh - 148px);
}
.overflow-y-auto {
  height: calc(100vh - 220px);
  overflow-y: auto;
}
</style>